$('body').on('click', '.open-primary-menu', function() {
    var $this = $(this);
    var menu = $this.parents('.primary-menu-wrapper');

    if(menu.hasClass('opened')) {
        closeDropdown();
        return false;
    }

    menu.addClass('opened');
    closeDropdown($this.parents('.primary-menu-wrapper').attr('data-dropdown'));
    return false;
});